import type { Child } from '../types/assessment.types';

export function syncChildId(children: Child[]): void {
  if (children.length === 0) {
    localStorage.removeItem('childId');
    return;
  }

  const storedChildId = localStorage.getItem('childId');

  if (!storedChildId || !children.some(c => String(c.id) === storedChildId)) {
    localStorage.setItem('childId', String(children[0].id));
  }
}
